<div class="form-group">
  <q9-content-loader [isLoading]="loading$ | async"></q9-content-loader>

  <ng-container *ngIf="!(loading$ | async)">
    <form
      #form="ngForm"
      class="form-group"
      name="selectColumnsForm"
      [formGroup]="selectMetadataForm">
      <mat-dialog-content class="content">
        <div class="inputs-container">
          <q9-text-field
            [label]="'RUBIC_CUBE.GRID_NAME' | translate"
            [placeholder]="'RUBIC_CUBE.ENTER_GRID_NAME' | translate"
            formControlName="gridName"></q9-text-field>

          <q9-textarea-field
            [label]="'RUBIC_CUBE.GRID_DESCRIPTION' | translate"
            [placeholder]="'RUBIC_CUBE.ENTER_GRID_DESCRIPTION' | translate"
            [maxRows]="4"
            formControlName="gridDescription"></q9-textarea-field>
        </div>

        <items-selector
          [availableItemsTitle]="'RUBIC_CUBE.AVAILABLE_METADATA'"
          [filterPlaceholder]="'RUBIC_CUBE.FILTER_METADATA'"
          [selectedItemsTitle]="'RUBIC_CUBE.SELECTED_METADATA'"
          [availableItems]="availableMetadata"
          [selectedItems]="selectedMetadata"
          [showSelectAll]="true"
          (validateSelectedItems$)="validate()"></items-selector>
      </mat-dialog-content>

      <mat-dialog-actions>
        <div
          class="left-side"
          [matTooltip]="disableTooltip"
          [matTooltipDisabled]="!disableGlobalViewCreation && !disablePrivateViewCreation">
          <mat-slide-toggle formControlName="isPrivate">
            <span class="inner-text q9-section-data">
              {{ 'RUBIC_CUBE.PRIVATE_VIEW_LBL' | translate }}
            </span>
          </mat-slide-toggle>
        </div>

        <div class="right-side">
          <q9-secondary-button mat-dialog-close>
            {{ 'POPUPS.CANCEL' | translate }}
          </q9-secondary-button>

          <div
            [matTooltip]="'RUBIC_CUBE.PRIVATE_VIEW_LIMIT_REACHED_TOOLTIP' | translate"
            [matTooltipDisabled]="!blockCreation">
            <q9-primary-button
              [disabled]="!isViewValid || blockCreation"
              (click)="form.onSubmit($event); onSubmit()">
              {{ 'RUBIC_CUBE.NEXT_BTN' | translate }}
            </q9-primary-button>
          </div>
        </div>
      </mat-dialog-actions>
    </form>
  </ng-container>
</div>
